module.exports = __webpack_public_path__ + "media/images/research-d771b0d17df2e9fed253760fdd1cabc3.jpg";